"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 拼接ws链接
 * @param tpl
 * @param params
 * @returns
 */
var generateWssUrl = function (tpl, params) {
    var url = Object.keys(params).reduce(function (res, curr) { return res.replace("{{" + curr + "}}", "" + params[curr]); }, tpl);
    return encodeURI(url);
};
exports.default = generateWssUrl;
//# sourceMappingURL=generateWssUrl.js.map